module.exports = {
	INIT_APP: 'init_app',
	SET_AGENCY: 'set_agency',
	SET_NETWORK: 'set_network',
	SET_HASWALLET: 'set_haswallet',
	SET_HASBACKUP: 'set_hasBackup',
	SET_WALLET: 'set_wallet',
	SET_SCANNED_DATA: 'set_scanned_eth_address',
	SET_APP_PASSCODE: 'set_app_passcode',
	SET_BALANCE: 'set_balance',
	ADD_RECENT_TX: 'add_recent_tx',
	SET_PROJECT: 'set_project',
	SET_TOTAL_BENEFICIARIES: 'set_total_beneficiaries',
	TOGGLE_FOOTER: 'toggle_footer',
	SET_LOADING: 'set_loading'
};
